'use client';

import React from 'react';
import { motion } from 'motion/react';
import NextLink from 'next/link';
import { withRef } from '@/lib/with-ref';
import type { LinkElement, LinkProps } from './types';

const Link = withRef<LinkElement, LinkProps>(
  ({ useDefaultAnimation = true, children, ...props }, ref) => {
    const Comp = motion.create(NextLink);

    const defaultAnimation = useDefaultAnimation
      ? {
          whileHover: { scale: 1.05 },
          whileTap: { scale: 0.9 },
        }
      : {};

    return (
      <Comp ref={ref} {...defaultAnimation} {...props}>
        {children}
      </Comp>
    );
  },
);

Link.displayName = 'Link';

export default React.memo(Link);
